import styled from 'styled-components';

const IconRestartStyled = styled.svg`
  fill: ${props => props.theme.colors.white};
  height: 25px;
  opacity: 0;
  padding: 5px;
  position: relative;
  transform: translate(0, 10px);
  transition: transform ${props => props.theme.transition.duration}
      ${props => props.theme.transition.easeInOut},
    opacity ${props => props.theme.transition.duration}
      ${props => props.theme.transition.easeOut};
  transition-delay: 0.25;
  width: 25px;
  z-index: 10;

  path {
    transform: translateY(10px);
  }

  .end-game-options-enter-done & {
    opacity: 1;
    transform: translate(0, 0);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 10px 10px 10px 0;
  }
`;

export default IconRestartStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/IconRestart/IconRestart.styled.js